(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/race-service/assets/javascripts/utils/pix-to-coupon.js') >= 0) return;  svs.modules.push('/components/racing/race-service/assets/javascripts/utils/pix-to-coupon.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$racing$common$co = svs.racing.common.constants,
  systemTypes = _svs$racing$common$co.systemTypes,
  quickpickProps = _svs$racing$common$co.quickpickProps;
const pixToTopRank = (pixData, pixSize, systemType) => {
  const row = pixData.row; 
  const normalizedRow = new Array(row.length);
  for (let i = 0; i < row.length; i++) {
    for (let k = 0; k < row[i].length; k++) {
      const pixPosition = row[i][k] - 1;
      const previousValue = normalizedRow[pixPosition] ? normalizedRow[pixPosition] : 0;
      const newValue = previousValue | 1 << i;
      normalizedRow[pixPosition] = newValue;
    }
  }
  return {
    row: normalizedRow,
    reserve: pixData.reserve - 1,
    qpValue: systemType === systemTypes.TOP_RANK_PIX ? quickpickProps.PARTIALQP : quickpickProps.WEIGHTEDQP,
    pixSize
  };
};
const pixToUnitCombined = (pixData, pixSize, numberOfParticipants) => {
  const row = pixData.row[0];
  const normalizedRow = new Array(numberOfParticipants).fill(undefined);
  for (let i = 0; i < row.length; i++) {
    const index = row[i] - 1;
    normalizedRow[index] = i + 1;
  }
  return {
    row: normalizedRow,
    reserve: pixData.reserve - 1,
    qpValue: quickpickProps.WEIGHTEDQP,
    pixSize
  };
};
const pixToWheel = (pixData, pixSize, numberOfParticipants) => {
  const _pixData$row = _slicedToArray(pixData.row, 2),
    base = _pixData$row[0],
    unordered = _pixData$row[1];
  const normalizedRow = new Array(numberOfParticipants).fill(undefined);
  for (let i = 0; i < normalizedRow.length; i++) {
    const participantNumber = i + 1;
    let value;
    if (base.indexOf(participantNumber) !== -1) {
      value = 1;
    } else if (unordered.indexOf(participantNumber) !== -1) {
      value = 2;
    }
    normalizedRow[i] = value;
  }
  return {
    row: normalizedRow,
    reserve: pixData.reserve - 1,
    qpValue: quickpickProps.WEIGHTEDQP,
    pixSize
  };
};
const pixToCoupon = (systemType, pixData, pixSize, numberOfParticipants) => {
  switch (systemType) {
    case systemTypes.UNIT_COMBINED:
    case systemTypes.UNIT_COMBINED_UNORDERED:
      return pixToUnitCombined(pixData, pixSize, numberOfParticipants);
    case systemTypes.TOP_RANK:
    case systemTypes.TOP_RANK_PIX:
      return pixToTopRank(pixData, pixSize, systemType);
    case systemTypes.WHEEL:
      return pixToWheel(pixData, pixSize, numberOfParticipants);
    default:
      return undefined;
  }
};
svs.racing.raceService.utils.pixToCoupon = pixToCoupon;

 })(window);